import ApiConstants from "../../Constants/ApiConstant";
import { apiGet } from "../../Services/ApiService";

export const getSearchAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.searchUrl}?search_query=${data}`)
        .then((response) => {
          callBack && callBack(response?.headers);
        })
        .catch((err) => {
          console.log("Error fetching search results:", err);
          throw err;
        });
    } catch (err) {
      console.log("Error fetching search results:", err);
      throw err;
    }
  };
};
